import { ApiLoadingService } from './api-loading.service';
import { Http, Headers, RequestOptions } from '@angular/http';
import { environment } from './../../../environments/environment';
import 'rxjs/add/operator/toPromise';
import { LocaleService } from './../seo/locale.service';
import { FormError, ApiError } from './../models/index';
var ApiCallService = /** @class */ (function () {
    function ApiCallService(http, localeService, apiLoadingService) {
        this.http = http;
        this.localeService = localeService;
        this.apiLoadingService = apiLoadingService;
        this.callsInProgress = 0;
    }
    ApiCallService.prototype.getBasePath = function () {
        return environment.baseApiPath + '/agencies/' + environment.agency_uuid;
    };
    ApiCallService.prototype.getRequestOptions = function () {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept-Language', this.localeService.getCurrentLocale());
        return new RequestOptions({ headers: headers });
    };
    ApiCallService.prototype.getSeachUrlParams = function (searchParams, sort, page) {
        var first = true;
        var path = '';
        var _loop_1 = function (field) {
            if (searchParams.hasOwnProperty(field)) {
                if (searchParams[field] !== null && searchParams[field] !== undefined && searchParams[field]) {
                    if (Array.isArray(searchParams[field])) {
                        searchParams[field].forEach(function (search) {
                            path += (first ? '?' : '&') + field + '[]=' + search;
                            first = false;
                        });
                    }
                    else {
                        path += (first ? '?' : '&') + field + '=' + searchParams[field];
                        first = false;
                    }
                }
            }
        };
        for (var field in searchParams) {
            _loop_1(field);
        }
        if (page) {
            path += (first ? '?' : '&') + 'page=' + page;
        }
        if (sort) {
            path += (first ? '?' : '&') + 'sort=' + sort;
            first = false;
        }
        return path;
    };
    ApiCallService.prototype.startApiCall = function () {
        this.callsInProgress++;
        if (this.callsInProgress === 1) {
            this.apiLoadingService.startLoading();
        }
    };
    ApiCallService.prototype.finishApiCall = function () {
        this.callsInProgress--;
        if (this.callsInProgress < 0) {
            this.callsInProgress = 0;
        }
        if (this.callsInProgress === 0) {
            this.apiLoadingService.stopLoading();
        }
    };
    // Standard HTTP requests
    ApiCallService.prototype.get = function (path, basePath) {
        var _this = this;
        if (basePath === undefined) {
            basePath = this.getBasePath();
        }
        this.startApiCall();
        return this.http
            .get(environment.apiUrl + '/' + basePath + path, this.getRequestOptions())
            .toPromise()
            .then(function (response) { return _this.handleResponse(response); })
            .catch(function (response) { return _this.handleError(response); });
    };
    ApiCallService.prototype.post = function (path, data, basePath) {
        var _this = this;
        if (basePath === undefined) {
            basePath = this.getBasePath();
        }
        this.startApiCall();
        return this.http
            .post(environment.apiUrl + '/' + basePath + path, data, this.getRequestOptions())
            .toPromise()
            .then(function (response) { return _this.handleResponse(response); })
            .catch(function (response) { return _this.handleError(response); });
    };
    ApiCallService.prototype.put = function (path, data, basePath) {
        var _this = this;
        if (basePath === undefined) {
            basePath = this.getBasePath();
        }
        this.startApiCall();
        return this.http
            .put(environment.apiUrl + '/' + basePath + path, data, this.getRequestOptions())
            .toPromise()
            .then(function (response) { return _this.handleResponse(response); })
            .catch(function (response) { return _this.handleError(response); });
    };
    ApiCallService.prototype.delete = function (path, data, basePath) {
        var _this = this;
        if (basePath === undefined) {
            basePath = this.getBasePath();
        }
        this.startApiCall();
        return this.http
            .delete(environment.apiUrl + '/' + basePath + path, { body: data })
            .toPromise()
            .then(function (response) { return _this.handleResponse(response); })
            .catch(function (response) { return _this.handleError(response); });
    };
    ApiCallService.prototype.patch = function (path, data, basePath) {
        var _this = this;
        if (basePath === undefined) {
            basePath = this.getBasePath();
        }
        this.startApiCall();
        return this.http
            .patch(environment.apiUrl + '/' + basePath + path, data, this.getRequestOptions())
            .toPromise()
            .then(function (response) { return _this.handleResponse(response); })
            .catch(function (response) { return _this.handleError(response); });
    };
    ApiCallService.prototype.head = function (path, basePath) {
        var _this = this;
        if (basePath === undefined) {
            basePath = this.getBasePath();
        }
        this.startApiCall();
        return this.http
            .head(environment.apiUrl + '/' + basePath + path, this.getRequestOptions())
            .toPromise()
            .then(function (response) { return _this.handleResponse(response); })
            .catch(function (response) { return _this.handleError(response); });
    };
    ApiCallService.prototype.options = function (path, basePath) {
        var _this = this;
        if (basePath === undefined) {
            basePath = this.getBasePath();
        }
        this.startApiCall();
        return this.http
            .options(environment.apiUrl + '/' + basePath + path, this.getRequestOptions())
            .toPromise()
            .then(function (response) { return _this.handleResponse(response); })
            .catch(function (response) { return _this.handleError(response); });
    };
    ApiCallService.prototype.handleResponse = function (response) {
        this.finishApiCall();
        if (response.status === 204) {
            return null;
        }
        return response.json();
    };
    ApiCallService.prototype.handleError = function (errorResponse) {
        var error;
        this.finishApiCall();
        if (errorResponse.status === 400 || errorResponse.status === 422) {
            error = new FormError();
        }
        else {
            error = new ApiError();
        }
        error.code = errorResponse.status;
        error.message = errorResponse.statusText ? errorResponse.statusText : errorResponse;
        if (errorResponse.json) {
            error.errors = errorResponse.json().errors;
        }
        error.api_raw_response = errorResponse;
        console.error(error);
        throw error;
    };
    return ApiCallService;
}());
export { ApiCallService };



// WEBPACK FOOTER //
// ./src/app/common-theme/api/api-call.service.ts.pre-build-optimizer.js